<template>
  <div>
    <div class="d-flex" id="wrapper">
      <!-- Sidebar -->
      <SideBar/>
        <!-- /#sidebar-wrapper -->
        <!-- Page Content -->
        <div id="page-content-wrapper">
          <nav style="justify-content:flex-start;" class="navbar navbar-expand-lg navbar-light bg-light border-bottom floating">
            <div>
              <button class="btn btn-outline" id="menu-toggle" @click="sidebar"><span class="navbar-toggler-icon"></span>
              </button>

              <button style="color: rgba(0,0,0,.5);border-color: rgba(0,0,0,.1);" class="btn btn-outline navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span style="padding-top:0.5em;"><i class="fas fa-user-alt"></i><span class="account-div"></span><i class="fas fa-angle-down"></i></span>
              </button>
            </div>
            <div class="d-flex">
              <!-- <i class="fas fa-home text-muted hover-cursor" @click="toPage('/dashboard')"></i> -->
              <p class="text-muted mb-0 hover-cursor" @click="toOrderPage">&nbsp;Order&nbsp;</p>
              <p class="text-primary mb-0 hover-cursor">/&nbsp;extend</p>
            </div>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
              <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
                <li class="nav-item dropdown">
                  <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    {{ admin }}
                  </a>
                  <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                    <a class="dropdown-item link" @click="toPage('/password')"> <i class="fas fa-cog"></i><span class="right-dropdown">Change Password</span></a>
                    <a class="dropdown-item link" @click="handleLogout"><i class="fas fa-sign-out-alt"></i><span class="right-dropdown">Logout</span></a>
                  </div>
                </li>
              </ul>
            </div>
          </nav>
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-12 grid-margin stretch-card card-div">
                <div class="container">
                  <h5 class="mb-4">Extend Order<br><b>{{$route.query.orderCode}}</b></h5>
                  <div v-for="(data,index) in dataExtend" :key="`extend-${index}`">
                    <div class="product-title">
                      {{data.productTitle}} ({{data.condition}})
                    </div>
                    <div class="product-title mb-2">
                      {{data.specifications}}
                    </div>
                    <div class="row mb-1">
                      <div class="col-3">
                        <input type="text" name="" placeholder="Input Product Code/SN" class="form-control form-control-sm field-product-code" v-model="fieldFilterCode[index]">
                        <!-- @keyup.enter="filterByCode(index,fieldFilterCode[index])"> -->
                      </div>
                      <div class="col-3">
                        <div class="d-flex align-items-center">
                          Set 
                          <input type="number" name="" class="form-control form-control-sm field-duration ml-2 mr-2" placeholder="Duration" v-model="fieldFilterDuration[index]" @keypress="isNumber($event)" min="1"> Months 
                          <button class="btn btn-sm btn-primary ml-2" @click="updateMonth(index,data.item)"> Update</button>
                          </div>
                      </div>
                      <div class="col-3">
                        <div class="d-flex align-items-center">
                          Set 
                          <input type="number" name="" class="form-control form-control-sm field-price ml-2 mr-2" placeholder="Price" v-model="fieldFilterPrice[index]" @keypress="isNumber($event)" min="0">
                          <button class="btn btn-sm btn-primary" @click="updatePrice(index,data.item)"> Update</button>
                      </div>
                    </div>
                      <div class="col-3">
                        <input type="checkbox" :id="index" :value="index" @change="checkAll(index)"> Check All
                      </div>
                    </div>
                    <table class="fixed_header table-bordered table-striped table-responsive-sm w-100 table-sm mb-3">
                        <tbody>
                            <tr>
                                <th>Product Code/Serial Number</th>
                                <th>Duration</th>
                                <th>Price</th>
                                <th>Item Selected</th>
                            </tr>
                            <tr v-for="(dataItem,idx) in filterByCode(index,fieldFilterCode[index])" :key="idx">
                                <td>{{dataItem.productCode}}/{{dataItem.serialNumber}}</td>
                                <td><input type="number" :id="'duration_' + dataItem.orderDetailsId" name="" v-model="dataItem.duration" style="width: 50px;" @keypress="isNumber($event)" min="1"> Months</td>
                                <td><input type="number" :id="'price_' + dataItem.orderDetailsId" name="" v-model="dataItem.itemPrice" style="width: 100px;" @keypress="isNumber($event)" min="0"></td>
                                <td><input type="checkbox" :id="dataItem.orderDetailsId"  v-model="dataItem.checked" :true-value="parseInt(dataItem.orderDetailsId)" @change="checkOne(index,dataItem.orderDetailsId,dataItem)">
                                </td>
                            </tr>
                            <tr v-if="filterByCode(index,fieldFilterCode[index]).length == 0">
                                <td colspan="4" class="text-center">Data Not Available</td>
                            </tr>
                        </tbody>
                    </table>
                  </div>
                  <div class="row d-flex flex-row-reverse mr-1">
                    <button class="btn btn-sm btn-primary ml-2" @click="submitExtendOrder" :disabled="loadingButtonSave"><img src="~@/assets/images/2.gif" style="height: 18px;" v-if="loadingButtonSave"> save </button>
                    <button class="btn btn-sm btn-danger" @click="toDetail(orderId)"> cancel </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /#page-content-wrapper -->
      </div>
    </div>
  </template>

<script>
  import SideBar from '../SideBar'
  import Multiselect from 'vue-multiselect'
  import 'vue-multiselect/dist/vue-multiselect.min.css'
  export default {
    name: 'OrderPage',
    components:{
      SideBar,
      Multiselect
    },
    data () {
      return {
        orderId:'',
        dataExtend:[],
        fieldFilterCode:[],
        fieldFilterDuration:[],
        fieldFilterPrice:[],
        loadingButtonSave:false
      }
    },
    computed:{
        
    },
    methods: {
      toNewOrderDetail(id, orderCode, companyId){
        window.open(this.$router.resolve('/order/detail/' + id +'?orderCode=?'+orderCode+'&companyIdDetail='+companyId).href, '_blank');
      },
      toDetail(id){
        this.$router.push({path:'/order/detail/' + id, query: {
              orderCode: this.$route.query.orderCode,
              companyIdDetail: this.$route.query.companyId
            }
        })
      },
      submitExtendOrder(){
        //filter just item choosed
        let sendApi = true
        let dataSend = []
        let swalShow = false
        for (var i = 0; i < this.dataExtend.length; i++) {
          for (var j = 0; j < this.dataExtend[i].item.length; j++) {
            if (this.dataExtend[i].item[j].checked != false && (this.dataExtend[i].item[j].duration === '0' || this.dataExtend[i].item[j].duration === '')) {
              swal("Sorry", "Product duration must be fill or minimal duration 1 month" , "error", {
                  button: "Ok",
              })
              swalShow = true
              sendApi = false
            }else if (this.dataExtend[i].item[j].checked != false) {
              dataSend.push({
                orderDetailsId:parseInt(this.dataExtend[i].item[j].orderDetailsId),
                duration:parseInt(this.dataExtend[i].item[j].duration),
                price:parseInt(this.dataExtend[i].item[j].itemPrice)
              })
            }
          }
        }
        if (dataSend.length === 0 && !swalShow) {
          swal("Sorry", "Minimal 1 item choosed" , "error", {
              button: "Ok",
          })
        }else if (sendApi) {
          let self = this
          this.loadingButtonSave = true
          this.$http.post(process.env.CREATE_EXTEND_ORDER,{
            dataExtend: dataSend,
            orderId: Number(this.orderId)
          },
          {
            timeout: 30 * 1000,
            headers: {'Asani-Token':localStorage.getItem('jwt')}
          })
          .then(response => {
            if (response.data.status !== 200) {
              swal("Sorry", response.data.message, "error", {
                    button: "Ok",
              })
              if (response.data.status == 401) {
                this.handleLogout()
              }  
            } else{
              swal("Success", response.data.message , "success", {
                button: "Ok",
              }).then((value) => {
                this.toDetail(this.orderId)
                this.toNewOrderDetail(response.data.content.orderId,response.data.content.orderCode, response.data.content.companyId)
              })
            }
            this.loadingButtonSave = false
          })
          .catch(error => {
            if (!error.status) {
                self.loadingButtonSave = false
                self.getData()
                alert('Request timeout / error with api, please try again!')
            }
            swal("Sorry", error.response.data.message, "error", {
              button: "Ok",
            }).then(v => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            })
          })
          
        }
      },
      updatePrice(index,data){
        if (this.fieldFilterPrice[index] === '') {
          swal("Sorry", "Price must be fill", "error", {
                  button: "Ok",
          })
        }else{
          for (var i = 0; i < data.length; i++) {
            var myEle = document.getElementById("price_"+data[i].orderDetailsId);
            if(myEle){
                document.getElementById("price_"+data[i].orderDetailsId).value = this.fieldFilterPrice[index]
            }
            
            data[i].itemPrice=this.fieldFilterPrice[index]
          }
        }
      },
      updateMonth(index,data){
        if (this.fieldFilterDuration[index] === '' || this.fieldFilterDuration[index] === '0') {
          swal("Sorry", "Duration must be fill or minimal duration 1 month", "error", {
                  button: "Ok",
          })
        }else{
          for (var i = 0; i < data.length; i++) {
            var myEle = document.getElementById("duration_"+data[i].orderDetailsId);
            if(myEle){
                document.getElementById("duration_"+data[i].orderDetailsId).value = this.fieldFilterDuration[index]
            }
            data[i].duration=this.fieldFilterDuration[index]
          }
        }
      },
      checkOne(index,id,data){
        let checkAll = true
        for (var i = 0; i < this.dataExtend[index].item.length; i++) {
          if (this.dataExtend[index].item[i].checked === false) {
            checkAll = false
          }
        }
        if (checkAll === true) {
          document.getElementById(index).checked = true
        }else{
          document.getElementById(index).checked = false
        }
      },
      checkAll(index,data){
        if (document.getElementById(index).checked) {
          for (var i = 0; i < this.dataExtend[index].item.length; i++) {
            var myEle = document.getElementById(this.dataExtend[index].item[i].orderDetailsId);
            if(myEle){
                document.getElementById(this.dataExtend[index].item[i].orderDetailsId).checked=true
            }
            this.dataExtend[index].item[i].checked = parseInt(this.dataExtend[index].item[i].orderDetailsId)
          }
        }else{
          for (var i = 0; i < this.dataExtend[index].item.length; i++) {
            var myEle = document.getElementById(this.dataExtend[index].item[i].orderDetailsId);
            if(myEle){
                document.getElementById(this.dataExtend[index].item[i].orderDetailsId).checked=false
            }
            this.dataExtend[index].item[i].checked = false
          }
        }
      },
      filterByCode(index,productCode){
        for (var i = 0; i < this.dataExtend[index].item.length; i++) {
          if (this.dataExtend[index].item[i].checked != false) {
            // document.getElementById(this.dataExtend[index].item[i].orderDetailsId).checked=true
          }
        }
        if (productCode === '') {
          return this.dataExtend[index].item
        }else if (productCode != ''){
          return this.dataExtend[index].item.filter(function (el) {
            return el.productCode === productCode ||
                   el.serialNumber === productCode;
          });
        }
      },
      isNumber: function(evt) {
          evt = (evt) ? evt : window.event;
          var charCode = (evt.which) ? evt.which : evt.keyCode;
          if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
            evt.preventDefault();
          } else {
            return true;
          }
      },
      sidebar(){
        $("#wrapper").toggleClass("toggled");
      },
      toPage(e) {
        this.$router.push(e)
      },
      toOrderPage(){
        this.$router.push({path:'/order', 
              query: {
                  companyName: '',
                  orderId: '',
                  statusOrder: JSON.stringify([]),
                  picId: '',
                  picName: '',
                  deliveDateFrom: '',
                  deliveDateTo: '',
                  pickupDateFrom: '',
                  pickupDateTo: '',
                  itemPerPage: 10,
                  page:1
              }
        })
      },
      openModal(x,y) {
        this.idxNote = y
        $("#modal"+x).modal('show')
      },
      async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
        localStorage.removeItem('jwt')
        localStorage.removeItem('admin_name')
        localStorage.removeItem('roles')
        localStorage.removeItem('user_email')
        localStorage.removeItem('admin_id')
        localStorage.removeItem('changeCatalogPermission')
        this.$router.push('/')
      },
      cekLogin(){
        if (localStorage.getItem('jwt') == null) {
          this.$router.push('/')
        }
      },
      getData(){
        this.loadingTable = true
        this.loadingTableOrder = true
        this.orderId = this.$route.params.orderId
        this.$http.post(process.env.GET_EXTEND_ITEM,{
          orderId: this.orderId
        },
        {
          headers: {'Asani-Token':localStorage.getItem('jwt')}
        })
        .then(response => {
          if (response.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
                  button: "Ok",
                })
            this.handleLogout()
          }else{
            this.dataExtend = response.data.content
            this.fieldFilterCode = []
            this.fieldFilterPrice = []
            this.fieldFilterDuration = []
            for (var i = 0; i < this.dataExtend.length; i++) {
              this.fieldFilterCode.push('')
              if (this.dataExtend[i].item.length != 0) {
                this.fieldFilterPrice.push(this.dataExtend[i].item[0].itemPrice)
                this.fieldFilterDuration.push(this.dataExtend[i].item[0].duration)
              }else{
                this.fieldFilterPrice.push('')
                this.fieldFilterDuration.push('')
              }
              for (var j = 0; j < this.dataExtend[i].item.length; j++) {
                let array = {
                  duration:this.dataExtend[i].item[j].duration,
                  itemPrice:this.dataExtend[i].item[j].itemPrice,
                  orderDetailsId:this.dataExtend[i].item[j].orderDetailsId,
                  productCode:this.dataExtend[i].item[j].productCode,
                  serialNumber:this.dataExtend[i].item[j].serialNumber,
                  checked:false
                }
                this.dataExtend[i].item[j] = array
              }
            }
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
      },
      sendLog(x){
        var today = new Date();
        var month = today.getMonth()+1
        if (month < 10) {
            month = '0'+month
        }
        var dateDay = today.getDate()
        if (dateDay < 10) {
            dateDay = '0'+dateDay
        }
        var hours = today.getHours()
        if (hours < 10) {
            hours = '0'+hours
        }
        var minutes = today.getMinutes()
        if (minutes < 10) {
            minutes = '0'+minutes
        }
        var second = today.getSeconds()
        if (second < 10) {
            second = '0'+second
        }
        var date = today.getFullYear()+'-'+month+'-'+dateDay;
        var time = hours + ":" + minutes + ":" + second;
        var dateTime = date+' '+time;
        var admin = this.admin
        var command = 'add-logs'

        this.$http.post(process.env.LOG_URL+"/order/"+x,{
          codeLogs: 1,
          params: [],
        },{
          headers: {'Asani-Token':localStorage.getItem('jwt')}
        })
        .then(response => {
        })
        .catch(error => {
          console.log(error)
        })
      }
    },
    created(){
      this.getData()
      this.admin = localStorage.getItem('admin_name')
      this.adminId = localStorage.getItem('admin_id')
      this.cekLogin()
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .field-product-code{
    max-width: 180px;
  }
  .field-duration{
    max-width: 50px;
  }
  .field-price{
    max-width: 100px;
  }
  .product-title{
    font-weight: bold;
  }
  .fixed_header{
    table-layout: fixed;
    border-collapse: collapse;
  }

  .fixed_header tbody{
    display:block;
    overflow:auto;
    height:200px;
    width:100%;
  }

  .fixed_header tbody tr td{
    width:1578px;
  }

  .fixed_header thead tr{
    display:block;
  }

  .fixed_header th, .fixed_header td {
    padding: 5px;
    text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/Order/OrderExtendPage.vue